// extracted by mini-css-extract-plugin
export var attachment = "SectionImageRightTable-module--attachment--316ea";
export var backgroundImage = "SectionImageRightTable-module--backgroundImage--82f6c";
export var content = "SectionImageRightTable-module--content--56658";
export var cta = "SectionImageRightTable-module--cta--6f06a";
export var ctaGroup = "SectionImageRightTable-module--ctaGroup--2ac1a";
export var ctaWrapper = "SectionImageRightTable-module--ctaWrapper--91dd2";
export var learnMoreColumn = "SectionImageRightTable-module--learnMoreColumn--fe124";
export var middleColumn = "SectionImageRightTable-module--middleColumn--b240e";
export var sideColumn = "SectionImageRightTable-module--sideColumn--09b3b";
export var table = "SectionImageRightTable-module--table--32b35";
export var tableContainer = "SectionImageRightTable-module--tableContainer--58661";
export var title = "SectionImageRightTable-module--title--d060d";
export var wrapper = "SectionImageRightTable-module--wrapper--630c6";